import * as R from 'ramda';

import * as C from '../styled';

import {
    getRefinedField,
    getRefinedLevel,
    getRefinedOperator,
    getRefinedValues,
} from '../utils';

import FilterFormatterMixin from '@/components/Dashboard/common/UaFilterSettingPanel/mixin';

export default {
    name: 'FilterItem',
    mixins: [FilterFormatterMixin],
    props: {
        condition: {
            type: Object,
            required: true,
        },
        groupId: {
            type: String,
            default: undefined,
        },
    },
    render() {
        const { condition, groupId } = this;

        const refinedField = getRefinedField(condition);
        const refinedLevel = getRefinedLevel(condition);
        const refinedOperator = getRefinedOperator(condition);
        const refinedValues = getRefinedValues(condition);
        const truncatedValues = R.compose(
            R.when(() => refinedValues.length > 2, R.append('...')),
            R.take(2)
        )(refinedValues);

        const groupSetAccounts = groupId
            ? this.tableAdAccountsByFilterGroupId[groupId]
            : undefined;

        const levelTranslator = this.getLevelTranslator(refinedField);
        const valueTranslator = this.getValueTranslator(
            refinedField,
            groupSetAccounts
        );
        const valueLogoTranslator = this.getValueLogoTranslator(
            refinedField,
            groupSetAccounts
        );

        const subject = refinedLevel
            ? `${this.fieldTranslator(refinedField)}: ${levelTranslator(
                  refinedLevel
              )}`
            : this.fieldTranslator(refinedField);
        const verb = this.operatorTranslator(refinedOperator);

        const objects = refinedValues.map((value) =>
            valueTranslator(value, condition.field)
        );
        const tooltip = objects.join(', ');

        return this.wrapTooltip({
            visible: true,
            title: tooltip,
            content: (
                <C.Item>
                    {/* field, level */}
                    <C.ItemField>{subject}</C.ItemField>

                    {/* operator */}
                    <C.ItemOperator>{verb}</C.ItemOperator>

                    {/* value */}
                    <C.ItemValues>
                        {truncatedValues.map((value, idx) => {
                            if (value === '...') {
                                return (
                                    <C.ItemValue key={idx}>
                                        <C.ItemValueText>
                                            {value}
                                        </C.ItemValueText>
                                    </C.ItemValue>
                                );
                            }

                            return (
                                <C.ItemValue key={idx}>
                                    <C.ItemValue>
                                        {valueLogoTranslator && (
                                            <C.ItemValueLogo>
                                                {valueLogoTranslator(value)}
                                            </C.ItemValueLogo>
                                        )}
                                        <C.ItemValueText>
                                            {valueTranslator(
                                                value,
                                                condition.field
                                            )}
                                        </C.ItemValueText>
                                    </C.ItemValue>
                                </C.ItemValue>
                            );
                        })}
                    </C.ItemValues>
                </C.Item>
            ),
        });
    },
};
